import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=324641dd&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=js&"
export * from "./NotificationBar.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/notification-bar.scss?vue&type=style&index=0&id=324641dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324641dd",
  null
  
)

export default component.exports